import { render, staticRenderFns } from "./headerBottom.vue?vue&type=template&id=6b845398&scoped=true&"
import script from "./headerBottom.vue?vue&type=script&lang=js&"
export * from "./headerBottom.vue?vue&type=script&lang=js&"
import style0 from "./headerBottom.vue?vue&type=style&index=0&id=6b845398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b845398",
  null
  
)

export default component.exports